import { render, staticRenderFns } from "./IconStyling.vue?vue&type=template&id=6f6df50a"
import script from "./IconStyling.vue?vue&type=script&lang=js"
export * from "./IconStyling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports